module.exports = __webpack_public_path__ + "6dadfcdf674fb2f092ed17f856962964.svg";